{
  "active": {
    "name": "active",
    "badge": "default",
    "statusIdList": [4, 7, 9, 11]
  },
  "inactive": {
    "name": "inactive",
    "badge": "inactive"
  },
  "past": {
    "name": "past",
    "badge": "inactive"
  }
}
